/*global
    jQuery, aap, Awesomplete
*/
(function ($) {

    'use strict';

    var $rform = $('#registration'),
        $easyForm = $('#pet_submission_easy'),
        $sform = $('#suggestions-form'),
        isValid = false,
        $errorsHolder = $('ul.errors'),
        $breed = $('#breed'),
        $secondBreed = $('#second_breed');


    if($breed.length > 0) {
        var breedComplete = new Awesomplete(('#dummy_breed'), {
            replace: function (suggestion) {
                this.input.value = suggestion.label;
                $breed.val(suggestion.value);
            }
        });
        breedComplete.list = aap.breeds;
        if ( $secondBreed.length > 0 ) {
            var secondBreedComplete = new Awesomplete(('#dummy_second_breed'), {
                replace: function (suggestion) {
                    this.input.value = suggestion.label;
                    $secondBreed.val(suggestion.value);
                }
            });
            secondBreedComplete.list = aap.breeds;
        }

    }
    aap.validationErrors = [];


    var scrollToError = function() {
        $('html,body').animate({
            scrollTop: $errorsHolder.offset().top
        });
    };

    //use aap.checkField to validate input values
    var validate = function () {

        var $this = $(this),
            isOptional = $this.data('optional');


        if (!isOptional) {
            aap.checkField(this);
        }
    };

    // might need to move to a utility script
    //takes and array, returns array with unique elements
    function unique(value, index, self) {
        return self.indexOf(value) === index;
    }

    //aggregated error ul display
    var fillError = function() {
        var $errorUl = $errorsHolder,
            ml = [],
            errors = aap.validationErrors.filter(unique);

        for (var i = 0, l = errors.length; i < l; i++) {
            ml.push('<li>' + errors[i] + '</li>');
        }

        $errorUl.html(ml.join(''));
    };

    //updates UI after ajax validation
    var updateDom = function (res) {

        var data = JSON.parse(res.responseText);

        for (var field in data) {
            if (data.hasOwnProperty(field)) {

                var $field = $('#' + field);

                aap.validationErrors.push(data[field][0]);
                $field.removeClass('valid').addClass('error');
            }
        }
        $errorsHolder.show();
        fillError();
    };

    //init ajax validation
    var checkForm = function (e) {

        var $form = $(this),
            $allFields = $form.find('input, textarea, select'),
            nots = ':input[type=button], :input[type=submit], :input[type=reset], :input[type=hidden]',
            $fields = $allFields.not(nots),
            isRegistration = this.id === 'registration',
            isEasy = this.id === 'pet_submission_easy',
            submissionUrl = $form.data('validation_url');

        if(this.id === 'pet_submission_easy') {
            submissionUrl = $form.data('submission_url');
        }

        e.preventDefault();
        aap.validationErrors = [];

        $fields.each(validate);

        isValid = $fields.filter('.error').length === 0;

        if (!isValid) {
            $errorsHolder.show();
            fillError();
            scrollToError();
        }

        if (isValid) {
            var req = $.ajax({
                    type: 'POST',
                    url: submissionUrl,
                    data: $form.serialize()
                }),
                ajaxDone = function (d) {

                    if(isEasy) {
                        window.location.href = d.redirect_to.split('/')[1];
                        return;
                    }

                    if(!isRegistration && !isEasy) {
                        $('.message-sent').show();
                        return;
                    }

                    $form.off('submit').trigger('submit');
                };
            $errorsHolder.hide();

            req.fail(updateDom).done(ajaxDone);

        }

    };

    //reveals text option if select box has class more
    var revealOption = function () {
        var $this = $(this),
            value = $this.val(),
            checked = $this.is(':checked'),
            $more = $this.parents('.form-control').find('.more'),
            $bonded = $this.parents('.form-control').find('.bonded'),
            $bitten = $this.parents('form').find('.bitten-anyone');

        var name = $this.attr('name');
        if(value === 'dog' && (name == 'pet_type_1' || name === 'pet_type_2' || name === 'pet_type') ) {
            $bitten.removeClass('closed');
        } else if ( name !== 'bitten_anyone' && name !== 'spayed_neutered' && $this.parents('form').find('select[name="pet_type_1"]').val() !== 'dog' && $this.parents('form').find('select[name="pet_type_2"]').val() !== 'dog' && $this.parents('form').find('input[name="pet_type"]').val() !== 'dog' ) {
            $bitten.val('');
            $bitten.addClass('closed');
        }

        if ( typeof name !== 'undefined' && name !== '' && (name == 'pet_type_1' || name == 'pet_type_2') ) {
            $more.addClass('closed');
            return;
        }

        // Reset bonded pet_type child fields that may have been set in error if parent bonded field is not set to bonded
        if ( typeof name !== 'undefined' && name === 'pet_type' && value !== 'bonded' ) {
            $.each(['pet_type_1', 'pet_type_2'], function(i,name) {
                $('select[name="'+name+'"]').val('');
            });
        }

        if (value === 'none' || checked) {
            $bonded.addClass('closed');
            $more.removeClass('closed');
            return;
        }

        if(value === 'bonded') {
            $more.addClass('closed');
            $bonded.removeClass('closed');
            return;
        }

        if(value === 'yes' && name === 'bitten_anyone'){
            $this.parents('.form-control').find('.more-message').removeClass('closed');
            $this.parents('form').find('input[type="submit"]').attr('disabled', 'disabled');
        } else if (name === 'bitten_anyone'){
            var $message = $this.parents('.form-control').find('.more-message');
            if ($message.hasClass('closed')) {
                $this.parents('form').find('input[type="submit"]').removeAttr('disabled', 'disabled');
            } else {
                $message.addClass('closed');
                $this.parents('form').find('input[type="submit"]').removeAttr('disabled', 'disabled');
            }
        }

        $more.addClass('closed');
        $bonded.addClass('closed');

        // If selecting less than a week for rehome_deadline, display warning message
        // Removed until clear on text to display
        //if($this.attr('name') != undefined && $this.attr('name') == 'rehome_deadline') {
        //    if(value === '0') {
        //        $this.siblings('span.warning').text('With a deadline of less than one week, Adopt-a-Pet.com cannot guarantee that this service will help you to rehome your pet.').show();
        //    } else {
        //        $this.siblings('span.warning').hide();
        //    }
        //}
    };

    //after uploads go to next step
    var navigateToUrl = function (e) {
        var $this = $(this),
            url = $this.data(url);

        e.preventDefault();

        if (aap.uploaded && aap.uploaded.length > 0) {
            window.location.href = url.url;
            return;
        }

        $this.parents('.form-control').find('span').addClass('nouploads');
    };

    //modal for checkboxes
    var floater = function () {
        var $this = $(this),
            value = $this.val(),
            checked = $this.is(':checked'),
            link = $this.data('link'),
            $more = $(link);

        if (value === 'none' || checked) {
            $more.removeClass('closed');
            return;
        }

        $more.addClass('closed');
    };

    var closeFloater = function() {
        $('.more.checkbox-has-more').addClass('closed');
    };

    //dummy fields are used for visual display
    var populateReal = function () {
        var $medicalNeeds = $('#medical_needs'),
            $behavioralIssues = $('#behavioral_issues'),
            medicalNeedsValue = $('#medical_needs_dummy').val(),
            behavioralIssuesValue = $('#behavioral_issues_dummy').val();

        $medicalNeeds.val(medicalNeedsValue);
        $behavioralIssues.val(behavioralIssuesValue);

        closeFloater();
    };

    //enable disabled button if terms are accepted
    var enableButton = function() {
        var id = this.id,
            $button = $('[data-' + id + ']'),
            isDisabled = $button.is(':disabled');

        if (!isDisabled) {
            $button.prop('disabled', true);
            return;
        }
        $button.prop('disabled', false);
    };

    if ($errorsHolder.is(':visible')) {
        scrollToError();
    }
    var showArrow = function() {
        var $parent = $(this).parents('div.awesomplete');
        $parent.addClass('active');
    };
    var removeArrow = function() {
        var $parent = $(this).parents('div.awesomplete');
        $parent.removeClass('active');
    };
    //events
    $('select').on('change', revealOption);
    $('#no-help-needed-11').on('change', revealOption);
    $('.has-more').on('change', floater);
    $('.goto7').on('click', navigateToUrl);
    $('.additional').on('click', populateReal);
    $('#agree').on('click', enableButton);
    $rform.on('submit', checkForm);
    $sform.on('submit', checkForm);
    $easyForm.on('submit', checkForm);
    $('#suggestions-close').on('click', closeFloater);
    $('.server-errors').siblings('.errors').show();
    $('.contract').find('.errors').show(scrollToError);
    $('input.awesomplete').on('focus', showArrow);
    $('input.awesomplete').on('blur', removeArrow);
}(jQuery));
